import { getBackendUrl } from '../../utils/apiUrl';

export const coverageApiOrigin = () =>
  window.__RX_COVERAGE_API__ || getBackendUrl();
export async function coverageFetch(
  path,
  { token, method = 'GET', body, signal, origin = coverageApiOrigin() } = {},
) {
  const response = await fetch(`${origin}${path}`, {
    method,
    signal,
    credentials: 'omit',
    cache: 'no-store',
    referrerPolicy: 'no-referrer',
    headers: {
      ...(body ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok)
    throw new Error(
      Array.isArray(data.message)
        ? data.message.join(' ')
        : data.message || 'Could not reach RxRooster. Please try again.',
    );
  return data;
}
export const fragmentValue = (name) =>
  new URLSearchParams(window.location.hash.slice(1)).get(name) || '';
export const download = (name, content, type = 'text/plain') => {
  const url = URL.createObjectURL(new Blob([content], { type }));
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export function invitationText(partner) {
  return `Subject: ${partner.name} + RxRooster: provider coverage search\n\nHi ${partner.name} team,\n\nI'd like to invite you to integrate RxRooster's anesthesia provider coverage search into your system. Your team can open a known coverage gap, review providers' published service terms, and express interest inside your scheduling workflow, then continue the negotiation in the existing RxRooster Pipeline.\n\nSee the experience with fictional sample providers:\n${partner.demoUrl}\n\nFor your IT team: private setup guide:\n${partner.setupUrl}\n\nPlease share the private setup link only with your implementation team. It expires in 30 days. The demo does not contact providers or change a schedule.\n\nNo key is needed to view the demo. Your IT team uses the private setup guide to create a sandbox key, put it in their server settings, and run a test. After their test succeeds, RxRooster reviews and enables live access. Each customer confirms its company details or signs in; its opening and shortlist continue in RxRooster.\n\nAlma\nRxRooster`;
}
